import React, { Component } from 'react';
import { connect } from 'react-redux';
import ShareLink from 'react-twitter-share-link';

import { changeColor, fetchQuote } from '../actions/FetchAction';

import './QuoteController.css';

class QuoteController extends Component {

	constructor(props){
		super(props);
		this.handleClick = this.handleClick.bind(this);
	}
	
	handleClick(){
		this.props.fetchQuote();
		this.props.changeColor();
	}

	render(){
		
		const style = { 
			backgroundColor: this.props.color 
		}

		const letterStyle = {
			color: this.props.color
		}

		const { author, quote } = this.props.quoteInfo;
		let text = `${quote} - ${author}`;

		return (
			<div className="quote-controller" >
				<div className="social-links">

					<ShareLink 
						text={text}
						hashtags= {['freecodecamp', 'quotes']}
						via="RenatoFranciaC"
						>
					   {link => (
							<a href={link} 
								style={ letterStyle }
								target='_blank'
							>
								<i className="fab fa-twitter-square"></i>
							</a>
						)}
					</ShareLink>
					
				</div>
				<button 
					className="reset-quote" 
					style={style}
					onClick={this.handleClick}>New Quote</button>
			</div>
		);
	}
}

const mapStateToProps = state => ({
	color: state.settings.color,
	quoteInfo: state.settings.quoteInfo
});

export default connect(mapStateToProps, {changeColor, fetchQuote})(QuoteController);
